import React from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useSuccessErrorModal from "../../../hooks/successErrorModal/useSuccessErrorModal";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Radio, Select, Spin, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import Endpoints from "../../../api/endpoints";
import EndpointFunctions from "../../../utils/Functions/endpointFunctions";
import routes from "../../../utils/routes";

const sendGroup = [
  { label: "Konuya Gönder", value: Endpoints.sendToTopic },
  { label: "Dükkan Kullanıcılarına Gönder", value: Endpoints.sendToShopUsers },
  { label: "Bireysel Kullanıcılara Gönder", value: Endpoints.sendToClients },
  { label: "Tüm Kullanıcılara Gönder", value: Endpoints.sendToAll },
];

const TARGET_DESCRIPTIONS = {
  [Endpoints.sendToTopic]: "seçilen konuya abone tüm kullanıcılar",
  [Endpoints.sendToShopUsers]: "tüm dükkan kullanıcıları",
  [Endpoints.sendToClients]: "tüm bireysel kullanıcılar",
  [Endpoints.sendToAll]:
    "tüm kullanıcılar (bireysel müşteriler + dükkan kullanıcıları)",
};

const filterOption = (input, option) =>
  (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

const SendNotificationForm = ({ topicsMenu, isTopicsLoading }) => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();

  const [radioValue, setRadioValue] = useState(Endpoints.sendToAll);
  const [isLoading, setIsLoading] = useState(false);

  const sendNotification = async ({ values, endpoint }) => {
    setIsLoading(true);
    const result = await EndpointFunctions.postData({
      endpointURL: endpoint,
      axiosPrivate: axiosPrivate,
      requestBody: values,
    });

    if (result.success) {
      setIsLoading(false);
      showModal("Başarılı", "Bildirim başarıyla gönderildi.", () => {
        closeModal();
        navigate(routes.appNotifications);
      });
    } else {
      setIsLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  const handleRadioChange = ({ target: { value } }) => {
    setRadioValue(value);
  };

  const confirmAndSend = (values) => {
    const targetDescription = TARGET_DESCRIPTIONS[radioValue];

    Modal.confirm({
      title: "Bildirim Gönderimini Onaylayın",
      icon: <ExclamationCircleOutlined style={{ color: "#ff4d4f" }} />,
      width: 540,
      content: (
        <div>
          <p style={{ marginTop: 0 }}>
            Aşağıdaki bildirim <strong>{targetDescription}</strong> kitlesine
            gönderilecek.
            <br />
            <strong style={{ color: "#ff4d4f" }}>
              Bu işlem geri alınamaz.
            </strong>
          </p>
          <div
            style={{
              background: "#fafafa",
              padding: 12,
              borderRadius: 4,
              marginTop: 12,
              border: "1px solid #f0f0f0",
            }}>
            <div>
              <strong>Başlık:</strong> {values.title}
            </div>
            <div style={{ marginTop: 6 }}>
              <strong>İçerik:</strong> {values.body}
            </div>
            {values.imageUrl && (
              <div style={{ marginTop: 6, wordBreak: "break-all" }}>
                <strong>Görsel:</strong> {values.imageUrl}
              </div>
            )}
            {radioValue === Endpoints.sendToTopic && values.topic && (
              <div style={{ marginTop: 6 }}>
                <strong>Konu:</strong> {values.topic}
              </div>
            )}
          </div>
        </div>
      ),
      okText: "Gönder",
      okButtonProps: { danger: true },
      cancelText: "Vazgeç",
      onOk: () => sendNotification({ values, endpoint: radioValue }),
    });
  };

  return (
    <>
      <Radio.Group
        options={sendGroup}
        onChange={handleRadioChange}
        value={radioValue}
      />

      <div style={{ height: 20 }} />

      <Form
        name="send_notification"
        layout="vertical"
        onFinish={confirmAndSend}>
        <Form.Item
          name="title"
          label="Bildirim Başlığı:"
          rules={[
            { required: true, message: "Lütfen bildirim başlığını giriniz!" },
          ]}>
          <Input placeholder="Başlık" />
        </Form.Item>

        <Form.Item
          name="body"
          label="Bildirim İçeriği:"
          rules={[
            { required: true, message: "Lütfen bildirim içeriğini giriniz!" },
          ]}>
          <Input placeholder="İçerik" />
        </Form.Item>

        <Form.Item name="imageUrl" label="Görsel URL:">
          <Input placeholder="Görsel URL" />
        </Form.Item>

        {radioValue === Endpoints.sendToTopic && (
          <Spin spinning={isTopicsLoading}>
            <Form.Item
              name="topic"
              label="Konu Seçin:"
              rules={[
                { required: true, message: "Lütfen bir konu seçiniz!" },
              ]}>
              <Select
                placeholder="Konu"
                style={{ width: "100%" }}
                allowClear
                options={topicsMenu}
                filterOption={filterOption}
              />
            </Form.Item>
          </Spin>
        )}

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Bildirim Gönder
          </Button>
        </Form.Item>
      </Form>

      <Spin spinning={isLoading} fullscreen />

      <ModalComponent></ModalComponent>
    </>
  );
};

export default SendNotificationForm;
